import cn from 'classnames';

/* eslint-disable jsx-a11y/anchor-has-content */
import style from './ScrollDownArrow.module.scss';

export const ScrollDownArrow = ({ linkToId }: { linkToId: string }) => (
  <div className={style.container}>
    <a
      className={cn(style.arrow, 'tw:hover:before:bg-brand-primary')}
      href={`#${linkToId}`}
    />
  </div>
);
